export default __webpack_public_path__ + "d99db107575d113c9e196c6731578f81.png";